/**
 * abc-consent.js
 * Reads Shopify Customer Privacy API into window.__abc.consent.
 * Shopify is the source of truth — Ketch is the CMP that writes to it.
 *
 * Ketch purpose → Shopify API mapping (athleticbrewing config):
 *   essential_services     → preferencesProcessingAllowed() — always true, not used for gating
 *   analytics              → analyticsProcessingAllowed()
 *   behavioral_advertising → marketingAllowed()
 *
 * We do NOT read from Ketch directly. Ketch fires its consent event before
 * finishing its write to Shopify, so Shopify would be stale at that point.
 * visitorConsentCollected fires after the write is complete — that's our signal.
 *
 * Fires:
 *   abc:consentReady   — on first successful read
 *   abc:consentUpdated — on any subsequent change
 */
(function () {
  'use strict';

  var _ready = false;

  function read() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p) return false;

    window.__abc = window.__abc || {};
    window.__abc.consent = {
      // analyticsProcessingAllowed maps to Ketch's 'analytics' purpose
      // preferencesProcessingAllowed maps to 'essential_services' (always true — not a useful gate)
      preferences: !!(p.analyticsProcessingAllowed()),
      analytics:   !!(p.analyticsProcessingAllowed()),
      marketing:   !!(p.marketingAllowed()),
    };


    if (!_ready) {
      _ready = true;
      document.dispatchEvent(new CustomEvent('abc:consentReady', { detail: window.__abc.consent }));
    } else {
      document.dispatchEvent(new CustomEvent('abc:consentUpdated', { detail: window.__abc.consent }));
    }

    return true;
  }

  // Re-read after Ketch has finished writing to Shopify's cookie layer
  document.addEventListener('visitorConsentCollected', read);

  // On page load: retry until Shopify.customerPrivacy is available.
  // For returning visitors, consent is already stored and this resolves quickly.
  // For new visitors, this will resolve once Ketch initialises (typically < 500ms).
  var _attempts = 0;
  function tryRead() {
    if (read()) return;
    if (++_attempts < 30) {
      setTimeout(tryRead, 150); // up to ~4.5s
    } else {
      // Shopify.customerPrivacy never loaded (Ketch blocked by ad blocker etc.)
      // Opt-in model: no consent signal = no tracking
      window.__abc = window.__abc || {};
      window.__abc.consent = { preferences: false, analytics: false, marketing: false };
      document.dispatchEvent(new CustomEvent('abc:consentReady', { detail: window.__abc.consent }));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryRead);
  } else {
    tryRead();
  }

})();
